/* ==========================================================================
   MINI CART — three behaviours the design needs and Madrid has no setting for.
   Companion to `sections/stl-mini-cart.liquid`.

   1. The delivery line, placed between the header and the item list.
   2. The empty bag's two editor-controlled buttons.
   3. The quantity stepper's minus going from 1 to 0, which removes the line.

   THE DRAWER IS RE-RENDERED ON EVERY CART CHANGE. `cart.renderContents()`
   replaces its inner HTML wholesale, so the empty state and the item list appear
   and disappear repeatedly within one page life — a one-shot pass on load only
   works if the bag happens to be in the right state at that moment. Hence the
   observer. Source nodes are CLONED, never moved, so they survive a re-render.
   ========================================================================== */
(function () {
  'use strict';

  /* --- 1. the delivery line ---------------------------------------------- */

  function placeNote() {
    var src = document.querySelector('[data-stl-cart-note]');
    if (!src) return;

    /* KEYED ON `.drawer__inner-empty`, NOT ON THE ITEM LIST. An emptied drawer
       KEEPS its `<form class="cart__contents">` and an empty `.drawer__contents`
       inside it — so "is there a list?" is true in both states and a clone left
       over from the filled state would never be swept. `6491:8255` has no note,
       so the empty block is the thing to test. */
    var inners = document.querySelectorAll('.drawer .drawer__inner');
    for (var i = 0; i < inners.length; i++) {
      var inner = inners[i];
      var placed = inner.querySelector('.stl-cart-note');

      if (inner.querySelector('.drawer__inner-empty')) {
        if (placed) placed.remove();
        continue;
      }
      if (placed) continue;

      var list = inner.querySelector('.drawer__contents');
      if (!list || !list.parentElement) continue;

      var clone = src.cloneNode(true);
      clone.removeAttribute('hidden');
      clone.removeAttribute('data-stl-cart-note');
      list.parentElement.insertBefore(clone, list);
    }
  }

  /* --- 2. the empty bag's button pair ------------------------------------ */

  function placeCtas() {
    var src = document.querySelector('[data-stl-empty-ctas]');
    if (!src) return;

    var tops = document.querySelectorAll('.drawer .drawer__inner-empty .top');
    for (var i = 0; i < tops.length; i++) {
      var top = tops[i];
      if (top.querySelector('.stl-empty-ctas')) continue;

      var clone = src.cloneNode(true);
      clone.removeAttribute('hidden');
      clone.removeAttribute('data-stl-empty-ctas');
      top.appendChild(clone);

      /* Madrid's own <a class="button"> is hidden rather than removed, so its
         markup is still there if this section is taken out. A class rather than
         an inline style or [hidden], because `.button` sets
         `display: inline-flex` and beats the [hidden] UA rule. */
      var own = top.querySelector(':scope > .button');
      if (own) own.classList.add('stl-cta-superseded');
    }
  }

  /* --- 3. minus at 1 removes the line ------------------------------------ */

  /* MADRID ALREADY HAS THE WHOLE PATH; only the floor is wrong.
     `cart-drawer.liquid` writes `min="{{ item.variant.quantity_rule.min |
     default: 0 }}"`, and Shopify's default quantity rule minimum is **1**, not
     blank — so `default: 0` never fires and every input ships `min="1"`.
     `QuantityInput.setMinimumDisable()` then adds `.disabled` to the minus,
     which `base.css` gives `pointer-events: none`, so the control is dead at 1.

     Lowering the attribute to 0 is enough: `stepDown()` reaches 0, the change
     event fires, and `cart.js`'s `updateQuantity` posts quantity 0 to
     `/cart/change` — which is exactly what `CartRemoveButton` itself does
     (`updateQuantity(this.dataset.index, 0)`). Nothing is reimplemented and no
     core file is touched.

     `data-allow-zero` is Madrid's own flag, read by the input/paste handler,
     which would otherwise rewrite a typed 0 back up to the minimum.

     GUARDED ON `min === '1'`, so a product carrying a REAL quantity rule (a
     minimum of 2, say) keeps its floor and is not silently bypassed. */
  function allowZero() {
    var inputs = document.querySelectorAll('.drawer quantity-input .quantity__input');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input.dataset.stlZero === '1') continue;
      if (input.getAttribute('min') !== '1') continue;

      input.dataset.stlZero = '1';
      input.setAttribute('min', '0');
      input.dataset.allowZero = 'true';

      /* The class was added by the constructor while min was still 1, so it has
         to be cleared here; `setMinimumDisable()` re-runs on every later click
         and reads the new floor. */
      var minus = input.parentElement.querySelector('button[name="minus"]');
      if (minus && parseInt(input.value || '0', 10) > 0) minus.classList.remove('disabled');
    }
  }

  function run() {
    placeNote();
    placeCtas();
    allowZero();
  }

  function start() {
    run();
    var host = document.querySelector('cart-drawer') || document.body;
    new MutationObserver(run).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
